
import * as React from 'react';
import {useState, useEffect } from 'react';

// import {React, useState, useEffect } from 'react';
import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import '../App.css';
import { ethers } from 'ethers';
import axios from 'axios';

// Navbar components
	import { checkWalletStatus, getPreviousWallets, subscribeToWallets, checkPreviousWalletExists, listenForAccountChanges, listenForChainChanges, connectWallet, switchNetwork, switchNavConnectButtonText, bchainCheckAndButtonControl } from '../ResponsiveAppBar';
// import { listenForChainChanges, listenForAccountChanges } from './Create';

import { DataGrid, GridRowEditStartReasons } from '@mui/x-data-grid';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import FormHelperText from '@mui/material/FormHelperText';
import copy from 'copy-to-clipboard';

///////// Virtualized search window
//   // import * as React from 'react';
//   import PropTypes from 'prop-types';
//   // import TextField from '@mui/material/TextField';
//   import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
//   import useMediaQuery from '@mui/material/useMediaQuery';
//   import ListSubheader from '@mui/material/ListSubheader';
//   import Popper from '@mui/material/Popper';
//   import { useTheme, styled } from '@mui/material/styles';
//   import { VariableSizeList } from 'react-window';
//   // import Typography from '@mui/material/Typography';
/////////

// Polygon's Maticsjs and ethers plugin
    // import { use } from '@maticnetwork/maticjs'
    // import { Web3ClientPlugin } from '@maticnetwork/maticjs-ethers'

// Smart contract 
    import ProjectType1 from '../artifacts/contracts/ProjectType1.sol/ProjectType1.json';

// install ethers plugin (Polygon)
    // use(Web3ClientPlugin)

// Set base URLs & IDs
    let CONTRACT_ADDRESS, USER_API_ENDPOINT_ROOT, API_ENDPOINT_ROOT, PROVIDER_URL, NETWORK_CHAIN_ID, EXAMPLES_ADDRESS, EXAMPLE_INDEX_1, EXAMPLE_INDEX_2, EXAMPLE_COUNTER;

    if (process.env.NODE_ENV === "development") {
        console.log("local environment");
		CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_LOCAL;
		USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_LOCAL;
        API_ENDPOINT_ROOT = process.env.REACT_APP_API_ENDPOINT_ROOT_LOCAL;
        PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_LOCAL;
        NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_LOCAL;
        EXAMPLES_ADDRESS = process.env.REACT_APP_EXAMPLES_ADDRESS_LOCAL;
		EXAMPLE_INDEX_1 = process.env.REACT_APP_EXAMPLE_INDEX_1_LOCAL;
		EXAMPLE_INDEX_2 = process.env.REACT_APP_EXAMPLE_INDEX_2_LOCAL;
		EXAMPLE_COUNTER = process.env.REACT_APP_EXAMPLE_COUNTER_LOCAL;
    } else {
        console.log("production environment");
		CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_PRODUCTION;
		USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_PRODUCTION;
        API_ENDPOINT_ROOT = process.env.REACT_APP_API_ENDPOINT_ROOT_PRODUCTION;
        PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_PRODUCTION;
        NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_PRODUCTION;
        EXAMPLES_ADDRESS = process.env.REACT_APP_EXAMPLES_ADDRESS_PRODUCTION;
		EXAMPLE_INDEX_1 = process.env.REACT_APP_EXAMPLE_INDEX_1_PRODUCTION;
		EXAMPLE_INDEX_2 = process.env.REACT_APP_EXAMPLE_INDEX_2_PRODUCTION;
		EXAMPLE_COUNTER = process.env.REACT_APP_EXAMPLE_COUNTER_PRODUCTION;
    }

	EXAMPLE_INDEX_1 = Number(EXAMPLE_INDEX_1);
	EXAMPLE_INDEX_2 = Number(EXAMPLE_INDEX_2);


// PROXY trigger
	// Proxy variables (GLOBAL)
		let proxy;
		let proxyVar;
	// Reset blockchain connection
	export function resetConnection3() {
		console.log("resetConnection3 triggered");
		let randomNumber = Math.random();
		proxy.proxyVar = randomNumber;
	}


let account_global; // global
let contractPrimary_global, contractSecondary_global; // GLOBAL

  function Browse() {

    const navigate = useNavigate();
	const [projectInfoArray_db, setProjectInfoArray_db] = useState(null);
    const [tableData, setTableData] = useState('-----');
    const [maxArrIndex, setMaxIndex] = useState();
    const [selectedValue, setSelectedValue] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [web3Node, setWeb3Node] = useState('alchemy');
    const [shortAddress, setShortAddress] = useState('');

	const [emptyTable, setEmptyTable] = useState(false); // for testing max index=0
    const [ifEmptyShowEmpty, setIfEmptyShowEmpty] = useState(false);
	const [showExamples_state, setShowExamples] = useState(false);
	const [alreadyShowingExamples_state, setAreadyShowingExamples] = useState(false);

	const [username_state, setUsername] = useState(null);
	const [publicMode, setPublicMode] = useState(false);
	const [userAddrPublic, setUserAddrPublic] = useState(null);
	const [usernamePublic, setUsernamePublic] = useState(null);
	const [copyText, setCopyText] = useState('Copy Public URL of This Page');

	// const [showingMyPredictions, setShowingMyPredictions] = useState(false);

	// PROXY setup (Keep track of proxyVar for function trigger)
		// Proxy handler
		let proxyHandler = {
			set: function(target, property, value) {
				target[property] = value;
				// On variable change...
					setupBlockchain();
					return true;
			}
		};
		// Create a proxied variable which triggers above function on change
		proxy = new Proxy({ proxyVar: proxyVar }, proxyHandler);

	function makeProjectKey(_index, _address) {
		let inputData = ethers.utils.defaultAbiCoder.encode(['uint256', 'address'], [_index, _address]);
		let key = ethers.utils.keccak256(inputData);
		return key;
	}

    function makeShortAddress(address) { // Unused
        const accountTruncated = address.slice(0, 7) + '...' + address.slice(-4);
        setShortAddress(accountTruncated); // Unused
    }

	// Make Project Reference Number from project key (take first & last 4 characters and combine them with a hyphen, ingore "0x")
	function makeProjectRefNumber(_projectKey) {
		let _projectKeyStr = _projectKey.toString();
		let _projectKeyStrLength = _projectKeyStr.length;
		let _first4 = _projectKeyStr.slice(2, 6);
		let _last4 = _projectKeyStr.slice(_projectKeyStrLength - 4, _projectKeyStrLength);
		let _projectRefNumber = _first4 + '-' + _last4;
		return _projectRefNumber;
	}

	// Button - Copy URL & Share
		async function makePublicURL() {
			console.log("makePublicURL");
			// Get user blockchain account
				if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
					console.log("Wallet is installed");
					const wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
					account_global = wallet_accounts[0];
					console.log("Check accounts: ", wallet_accounts);
					console.log("Check account_global: " + account_global);
				} else {
					console.log("No wallet detected");
				}
			// Get current URL
			const currentURL = window.location.href;
			setCopyText('Copied!');
			console.log("Page Address Copied!");
			let finalURL = currentURL + "?user=" + account_global;
			copy(finalURL);
			console.log("finalURL: " + finalURL);
			setTimeout(function() {
				setCopyText('Copy Public URL of This Page');
			}, 3000); // delay of 3 sec
		}

	// Get URL parameter (if included)
		function getURLParameter(_param) {
			let pageURL = window.location.search.substring(1);
			let URLVariables = pageURL.split('&');
			for (let i = 0; i < URLVariables.length; i++) {
				let parameterName = URLVariables[i].split('=');
				if (parameterName[0] == _param) {
					return decodeURIComponent(parameterName[1]);
				}
				if (i == (URLVariables.length - 1)) {
					return "empty";
				}
			}
		}

	// Get user information from DB
		async function getUserInfoFromDB(_key, _keyType) { // blockchain, email or username
			console.log("function getUserInfoFromDB triggered * * * : " + _key + ", " + _keyType);
			return new Promise((resolve, reject) => {
				let postData = {
					type: 'query',
					query_type: 'latest',
					key: _key, // blockchain, email or username
					key_type: _keyType // 'email', 'bockchain', 'username', 'combined'
				};
				axios({ 
					url: USER_API_ENDPOINT_ROOT + "user-registry.php",
					method: "POST",
					data: JSON.stringify(postData),
				})
				.then((res) => { 
					const returned_data = JSON.parse(res.data.data);
					console.log("Check returned_data (user registry): ", returned_data);
					resolve(returned_data);
				}) 
				.catch((err) => { 
					console.log("error response: ", err);
				});
			});
		}

	// Check & process user info (address & username)
		async function checkAndProcessUserInfo_public(_paramUserAddress) {
			console.log("checkAndProcessUserInfo_public triggered");
			const userInfo = await getUserInfoFromDB(_paramUserAddress, 'blockchain');
			console.log("Check user info array: ", userInfo);
			if (userInfo === 'none' || userInfo['bchain_address'] === 'none') {
				setUserAddrPublic('Make sure you have the correct URL');
				setUsernamePublic('[User Not Found]');
			} else {
				setUserAddrPublic(_paramUserAddress);
				setUsernamePublic(userInfo['username']);
			}
		}

	// Get 'user' parameter (in URL), set address state, get username from DB * * *
		useEffect(() => {
			const paramUserAddress = getURLParameter('user');
			console.log("Check user param: " + paramUserAddress);
			if (paramUserAddress === 'empty') {
				setPublicMode(false);
			} else { // If PUBLIC MODE * * * *
				setPublicMode(true);
				displaySpecifiedUserProjects(paramUserAddress);
			}
		}, []);


	// Check and set up blockchain connection

		async function setupBlockchain(_mode = null) {

			console.log("= = = = setupBlockchain() triggered = = = =");
			// setShowLatestSubmission(false); // reset JIC
			console.log("Check mode param: " + _mode);

			// Check user connection to blockchain
				console.log("Call checkWalletStatus()");
				const connectionStatus = await checkWalletStatus();

			// Get user wallet account
				console.log("connectionStatus: ", connectionStatus);
				account_global = connectionStatus.walletAccount;

			// Check if user is connected to blockchain & manage button
				// try {
				// 	await bchainCheckAndButtonControl('skip wallet prompt');
				// } catch(err) {
				// 	console.log("Error: ", err);
				// }

				selectProviderAndContract(); // call the function
	
		} // End of setupBlockchain


	async function selectProviderAndContract() {

		console.log("= = = = selectProviderAndContract() triggered");

		// Check user connection to blockchain
			console.log("Call checkWalletStatus()");
			const connectionStatus = await checkWalletStatus();
				// Returned values (object) - walletInstalled, walletConnected, walletAccount, correctChain, allSet
				console.log("connectionStatus: ", connectionStatus);
				const userAccount_ = connectionStatus.walletAccount;

		// Set contract & settings
			if (connectionStatus.allSet == true) {
				
				console.log('selectProviderAndContract - using wallet: ' + userAccount_);

				// Set Wallet as primary provider, attach contract
					const provider_wallet = new ethers.providers.Web3Provider(window.ethereum);
					const signer_wallet = provider_wallet.getSigner();
					contractPrimary_global = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, signer_wallet);

					setWeb3Node('wallet');
					const paramUserAddress = getURLParameter('user'); // Doing this becaues 'publicMode' state doesn't work here (?)
					if (paramUserAddress === 'empty') { // If not public mode, show user's
						displayMyProjects(userAccount_); // 1st time calling this function upon page load
					}
				// Set Alchemy as seconary provider, attach contract
					const provider_api = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
					contractSecondary_global = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, provider_api);

			} else { // If not connected to blockchain, set Alchemy as primary provider

				console.log('selectProviderAndContract - using Alchemy');

				// Set Alchemy as primary provider, attach contract
					const provider_api = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
					contractPrimary_global = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, provider_api);

					const paramUserAddress = getURLParameter('user');

					if (paramUserAddress === 'empty') { // If not public mode, show user's
						displayMyProjects(); // 1st time calling this function upon page load

					} else { // If public mode, show empty table
						setWeb3Node('alchemy');
						setEmptyTable(true); // initial state
						setData([], 0); // initial state
					}
			}
	}

	
	async function displayMyProjects(_address = null) {
		console.log("'displayMyProjects' called " + _address);
		// setIfEmptyShowEmpty(false);

		if (_address == null) { 
			console.log("No user wallet, show example projects");
			setShowExamples(true); 
			console.log("Calling 'getProjectInfoArray' with EXAMPLES_ADDRESS: " + EXAMPLES_ADDRESS);
			getProjectInfoArray(EXAMPLES_ADDRESS);
			return;
		} 

        const userInfo = await getUserInfoFromDB(_address, 'blockchain');
		console.log("Check user info array: ", userInfo);
        setUsername(userInfo['username']); // Set username state * * *

		// Check max index
			const fetchMaxIndex = await getMaxIndex(_address);
			const maxIndex = Number(fetchMaxIndex);
			console.log('Check maxIndex (function getProjectInfoArray): ' + maxIndex);
		// Try retrieving projects from DB (to check if there's any)
			const retrievedFromDb = await retrieveProjectInfo_DB(_address);
			console.log("Check retrievedFromDb: ", retrievedFromDb);

		if (retrievedFromDb == 'empty' && maxIndex == 0) {
			console.log("No projects found for this address");
			setShowExamples(true); // new (6/4/25)
			console.log("Calling 'getProjectInfoArray' with EXAMPLES_ADDRESS: " + EXAMPLES_ADDRESS);
			getProjectInfoArray(EXAMPLES_ADDRESS);
		} else {
			console.log("Calling 'getProjectInfoArray' with address: " + _address);
			setShowExamples(false); // new (6/4/25)
			getProjectInfoArray(_address); 
		}
	}

	async function displaySpecifiedUserProjects(_forAddress) {
		console.log("'displaySpecifiedUserProjects' called");
		checkAndProcessUserInfo_public(_forAddress);
		setIfEmptyShowEmpty(true); // Making it 'false' here causes big error
		setEmptyTable(true); // reset JIC
		setData([], 0); // reset JIC
		setTimeout(function() {
			console.log("Time-delayed 'getProjectInfoArray' trigger");
			getProjectInfoArray(_forAddress);
		}, 2000); // delay of 2 sec (this is needed to wait for connectBlockchain => set contract with 1 sec delay)
	}

	async function checkCurrentNetwork() {
		let chainIdHex = await window.ethereum.request({ method: 'eth_chainId' });
		console.log('chain ID: ' + chainIdHex);
		return chainIdHex;
	}

	async function handleMainBlockchainButton() {
		await connectWallet(); // imported from ResponsiveAppBar
		await switchNetwork();
		setupBlockchain(); // on this page
	}

	function handleMyPredictions(_address) {
		console.log('My Predictions - clicked');
		setIfEmptyShowEmpty(true);
		getProjectInfoArray(_address);
	}


    async function findAddressFromDB(_selected) {

        console.log("000 Checking _selected: " + _selected);

        const filter = 'selected';
        const selected = _selected;

        let postData = { filter: filter, data: selected };
        await axios({ 
            url: API_ENDPOINT_ROOT + "search-fetch-db.php", // php files needs editing
            method: "POST",
            data: JSON.stringify(postData),
        })
          .then((res) => {
              const returned_data = JSON.parse(res.data.data);
              console.log("Checking returned_data: ", returned_data)
              console.log("Checking address --1: " + returned_data['accounts'][0])
              getProjectInfoArray(returned_data['accounts'][0]);
          }) 
          .catch((err) => { console.log("error response: " + err) });
    }

    async function getMaxIndex(_bc_address, _counter=0) {

        console.log('getMaxIndex called')
        console.log('...CONTRACT_ADDRESS: ' + CONTRACT_ADDRESS);
        console.log('...Check address: ' + _bc_address);

        try {
            let data = await contractPrimary_global.getMaxIndex(_bc_address);
            data = Number(data);
            console.log('Max index: ' + data)
            return data
        } catch (err) {
            console.log("getMaxIndex Error: " + err);
            console.log("Provider temporarily switching to Alchemy");
            let data2 = await getMaxIndex_secondaryRpc(_bc_address);
            return data2
        }  
    }

    async function getMaxIndex_secondaryRpc(_bc_address) {
		try {
			let data = await contractSecondary_global.getMaxIndex(_bc_address);
			data = Number(data);
			console.log('Max index (alt. RPC): ' + data);
			return data
		} catch (err) {
            console.log("getMaxIndex_secondaryRpc Error: " + err);
            console.log("Alchemy connectoin failed");
            return 'error';
		}
    }

    async function onchain_retrieveProjectInfoArray(_bc_address, _fromIndex, _toIndex) {

        console.log("onchain_retrieveProjectInfoArray called")
        console.log("CHECK _fromIndex: " + _fromIndex)
        console.log("CHECK _toIndex: " + _toIndex)

        try {
            console.log('Check address: ' + _bc_address);
            let data = await contractPrimary_global.retrieveProjectInfoArray(_bc_address, _fromIndex, _toIndex);
            console.log("Project info array fetched with no error");
            return data;
        } catch (err) {
            console.log("Project info array retrieval ERROR: ", err);
            console.log("Retrying with secondary provider (Alchemy)...");
            let data2 = await onchain_retrieveProjectInfoArray_secondaryProvider(_bc_address, _fromIndex, _toIndex);
			if (data2 == "error") {
				return;
			} else {
				return data2;
			}
        } 
    }

    async function onchain_retrieveProjectInfoArray_secondaryProvider(_bc_address, _fromIndex, _toIndex) {
		console.log("onchain_retrieveProjectInfoArray_secondaryProvider called");
		console.log("Provider temporarily switching to Alchemy");
        try {
            let data = await contractSecondary_global.retrieveProjectInfoArray(_bc_address, _fromIndex, _toIndex);
            console.log("Project info array fetched with no error (alt. API)");
            return data;
        } catch (err) {
            console.log("Project info array retrieval (alt. API) ERROR: ", err);

			setEmptyTable(true); // new (5/23/24)
			setData([], 0); // new
			setIfEmptyShowEmpty(true); // new

			return "error";
        }
    }


    async function getProjectInfoArray(_bc_address) { // From blockchain & DB

		console.log("= = = = getProjectInfoArray() triggered = = = =");

		// Variables
			let projectsArray_onchain = [], dividedByLimit, fullBatchCount, remainderCount, arraysBatch, fromIndex, toIndex, final, retrievedFromDb;
			let retrieveCount = 0;
			// For project examples 
				let showExamplesOnly = false; // initial

        // If it's for example projects list...
			if (_bc_address === EXAMPLES_ADDRESS && account_global !== EXAMPLES_ADDRESS) {
				console.log("This is for example projects list");
				// getExamplePredictionsData(_bc_address);
				// return;
				showExamplesOnly = true; // new (6/2/25)
				setShowExamples(true); // new (6/3/25)
				setIfEmptyShowEmpty(false); // new (6/3/25)
			}

        console.log("Checking address at getProjectInfoArray: " + _bc_address);

		// From Psiscope DB
			try {
				console.log("Calling retrieveProjectInfo_DB() with address: " + _bc_address);
				retrievedFromDb = await retrieveProjectInfo_DB(_bc_address);
				setProjectInfoArray_db(retrievedFromDb);
				console.log("Success - retrievedFromDb: ", retrievedFromDb);
			} catch (err) {
				console.log("retrievedFromDb Error: " + err);
				return;
			} 

		// From blockchain

        const fetchMaxIndex = await getMaxIndex(_bc_address);
        const maxIndex = Number(fetchMaxIndex);

		console.log('Check maxIndex (function getProjectInfoArray): ' + maxIndex);

		if (retrievedFromDb == 'empty' && maxIndex == 0) {
			console.log("No project found in DB or onchain - List examples instead");
			// getExamplePredictionsData(EXAMPLES_ADDRESS);
			setEmptyTable(true);
			setData([], 0);
			setShowExamples(true); // new (6/4/25)
			setIfEmptyShowEmpty(true);
			return;
		}
        
        const numberLimit = 40; // project number limit per batch (40) * * *

        if ((maxIndex + 1) > numberLimit) { // If there are more projects than batch number limit

			console.log("More projects than 1 batch number limit - retrieving in batches");

            dividedByLimit = (maxIndex + 1) / numberLimit;
            fullBatchCount = Math.floor(dividedByLimit);
            remainderCount = (maxIndex + 1) % numberLimit;
              console.log("dividedByLimit: " + dividedByLimit);
              console.log("fullBatchCount: " + fullBatchCount);
              console.log("remainder: " + remainderCount);

            manageBatchRetrieval() // Function triggered * * *

            async function manageBatchRetrieval(final = false) {
                console.log("CHECK 111");
                console.log("retrieveCount: " + retrieveCount);
				// Batch count check
                if (retrieveCount < fullBatchCount) { // if not yet final batch
                    console.log("CHECK 222");
                    retrieveBatch(retrieveCount+1);
                } else if (remainderCount > 0 && final == false) { // if final batch
                    retrieveBatch(retrieveCount+1, remainderCount);
                } else { // if all batches retrieved
                    console.log("Setting Data");
                    retrieveCount = remainderCount = 0;
					setData(projectsArray_onchain, maxIndex);
					setEmptyTable(false);
                }
            }

            async function retrieveBatch(_retrieveCount, _remainderCount=0) {

                console.log("CHECK 333")

                fromIndex = numberLimit * (_retrieveCount - 1);

                if (_remainderCount > 0) {
                  toIndex = fromIndex + (_remainderCount - 1);
                } else {
                  toIndex = fromIndex + (numberLimit - 1);
                }
                console.log("CHECK fromIndex: " + fromIndex)
                console.log("CHECK toIndex: " + toIndex)

				arraysBatch = await onchain_retrieveProjectInfoArray(_bc_address, fromIndex, toIndex);

				projectsArray_onchain = [...projectsArray_onchain, ...arraysBatch];

				console.log("CHECK 444")

                retrieveCount++;
				
                if (_remainderCount > 0) { // Would be 0 if not yet final batch
					final = true; // Means all done now
                } else {
					final = false;
                }
                manageBatchRetrieval(final);

            }

        } else { // If there are less projects than batch number limit

			console.log("Less projects than 1 batch number limit - retrieving all at once");

            if (maxIndex != 0) {
                projectsArray_onchain = await onchain_retrieveProjectInfoArray(_bc_address, 0, maxIndex);

				if (showExamplesOnly == true) {
					// projectsArray_onchain = makeExamplesList(projectsArray_onchain);
					console.log("Filtered projectsArray_onchain: ", projectsArray_onchain);
					setData(projectsArray_onchain, maxIndex);
					// setEmptyTable(true);
					setEmptyTable(false);
				} else {
					setData(projectsArray_onchain, maxIndex);
					setEmptyTable(false);
				}

            // Check if index "0" means no project or one project
            } else if (maxIndex == 0) {
                console.log('Checking index-0 project');
                projectsArray_onchain = await onchain_retrieveProjectInfoArray(_bc_address, 0, 0);
                let time = projectsArray_onchain[0].timeStamp;
                if (time > 0) {
                    console.log('Project found at index 0');
                    setEmptyTable(false);
                    setData(projectsArray_onchain, 0);

                } else { // This should be unnecessary, but just in case
                    console.log('No project found at index 0');
                    setEmptyTable(true); // Set it to true
                    setData(projectsArray_onchain, 0);
                }
            }
        }

    }

	async function getExamplePredictionsData(_forAddress) {

		console.log("getExamplePredictionsData triggered * * *");
		console.log("...Currently disabled");
		alert("getExamplePredictionsData called: " + _forAddress);

		// const projectsArray_onchain = await onchain_retrieveProjectInfoArray(_forAddress, 0, 2);
		// setEmptyTable(false);
		// setData(projectsArray_onchain, 2); // setData * * *

		// setEmptyTable(true); // new (5/23/24)
		// setData([], 0); // new
		// setIfEmptyShowEmpty(true); // new
	}

    async function getProjectWithTitleFromDB(_selected) { 

        console.log("checking _selected - rt5: " + _selected);

        const filter = 'selected_title';
        const selected = _selected;

        let postData = { filter: filter, data: selected };
        await axios({ 
            url: API_ENDPOINT_ROOT + "search-fetch-db.php", // php files needs editing
            method: "POST",
            data: JSON.stringify(postData),
        })
          .then((res) => {
              const returned_data = JSON.parse(res.data.data);
              // console.log("Check predictionArrays (from title): ", returned_data); // check array
              let length = returned_data[1].length;
              console.log("Check array length (from title): " + length);
              let maxIndex;
              if (length > 0) {
                  maxIndex = length - 1;
                  setEmptyTable(false);
                  setData(returned_data, maxIndex);
              } else {
                  console.log('No project found at index 0');
                  setEmptyTable(true);
                  setData(returned_data, 0);
              }
          }) 
          .catch((err) => { console.log("error response: " + err) });
    }

    function setData(_projectArrays, _maxIndex) {

		console.log("'setData' called");
		console.log("_maxIndex: " + _maxIndex);
		// console.log("_projectArrays: ", _projectArrays);
		setTableData(_projectArrays);
		setMaxIndex(_maxIndex);
    }

	function convertUnixTime(_unixTime) {
		let conversion = new Date(Number(_unixTime));
		conversion = conversion.toISOString();
		conversion = conversion.slice(0, 10); // "2023-11-24"
		// Create a Date object from the string
		const dateObject = new Date(conversion);
		// Options for formatting the date
		const options = { year: 'numeric', month: 'short', day: 'numeric' };
		// Format the date using toLocaleDateString ("Nov 14, 2023")
		let finalFormat = dateObject.toLocaleDateString('en-US', options);

		return finalFormat;
	}

	// Hash data

		function hashStringSolidityStyle(_string) { // keccak256
			// (Note: "toUtf8Bytes" matches Solidity's "encodePacked")
			let stringBytes = ethers.utils.toUtf8Bytes(_string);
			let hashedString = ethers.utils.keccak256(stringBytes);
			return hashedString;
		}

		// Hash data with SHA-256
		async function hashData(_data) { 
			return new Promise((resolve, reject) => {
				let postData = {
					original_data: _data,
				};
				axios({ 
					url: API_ENDPOINT_ROOT + "hash-function.php",
					method: "POST",
					data: JSON.stringify(postData),
				})
				.then((res) => { 
					const returned_data = res.data.hash;
					console.log("Returned hashed data: ", returned_data);
					resolve(returned_data);
				}) 
				.catch((err) => { console.log("error response: " + err) });
			});
		}

	async function retrieveProjectInfo_DB(_address) {

		console.log("retrieveProjectInfo_DB triggered");
		console.log("Check address: " + _address);
		return new Promise((resolve, reject) => {

			let postData = { address: _address, type: 'all' };
			axios({ 
				url: API_ENDPOINT_ROOT + "retrieve-data-db.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => {
				// console.log("Check res.data.data: ", res.data.data);
				const returned_data = JSON.parse(res.data.data);
				resolve(returned_data);
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}


  // Delayed triggering of connectBlockchain() * * * *
    // useEffect(
    //   () => {
    //     let timer1 = setTimeout(() => setupBlockchain(), 1000);
    //     return () => {
    //       clearTimeout(timer1);
    //     };
    //   }, [] // useEffect will run only one time with empty []
    // );
	useEffect(() => {
		setTimeout(function() {
			console.log ("setTimeout triggered - setupBlockchain");
			setupBlockchain();
		}, 1000); // delay of 1 sec
	}, []);

    // Table

      // Columns
        const columns = [
          { field: 'id', headerName: '#', type: 'number', width: 5 },
          { field: 'title', headerName: 'TITLE', width: 215 },
          { field: 'open', headerName: 'OPEN', width: 108 },
          { field: 'close', headerName: 'CLOSE', width: 108 },
          { field: 'restriction', headerName: 'FOR', width: 108 },
        ];

      // Rows
        const rows = [];

	  // Initialize variables
        let id_tb, title_tb, opentime_tb, closetime_tb, restriction_tb, restriction_db, index_num_db, title_hash_db, title_db, teamName_db, restriction_db_hash, newIdAndIndex, indexNumFromRowId_global = [];
		let exampleCounter_ = EXAMPLE_COUNTER;

		// Note: tableData is from blockchain
      
        if (emptyTable == false && maxArrIndex !== 'undefined') {

            console.log("emptyTable: " + emptyTable);
            console.log("check maxArrIndex: " + maxArrIndex);

			for (let i=maxArrIndex; i >= 0; i--) {

				if (showExamples_state == true) {
					if (i === EXAMPLE_INDEX_1 || i === EXAMPLE_INDEX_2) {
						makeRowsWithData(); 
					}
				} else {
					makeRowsWithData(); 
				}

				function makeRowsWithData() {

					// Project list number
						if (showExamples_state == true) {
							id_tb = exampleCounter_;
							exampleCounter_--;
						} else {
							id_tb = Number(i)+1;
						}

					// Added/revised on 2/19/25
						// Get project key from blockchain data
							let proj_mng_address = tableData[i].managerAddress; 
							let bchain_projectKey = makeProjectKey(i, proj_mng_address); 

						// Find in projectInfoArray_db.project_key[j] an entry that matches bchain_projectKey; get its index_num
							// Reset variables
							index_num_db = title_db = title_hash_db = restriction_db = teamName_db = null;
							// Loop through projectInfoArray_db.project_key
							for (let j=0; j < projectInfoArray_db.project_key.length; j++) {
								if (bchain_projectKey === projectInfoArray_db.project_key[j]) {
									index_num_db = projectInfoArray_db.index_num[j];
									title_db = projectInfoArray_db.title[j];
									title_hash_db = projectInfoArray_db.title_hash[j];
									restriction_db = projectInfoArray_db.restriction[j];
									teamName_db = projectInfoArray_db.team_name[j];
									break;
								}
							}
						// Add index_num_db to state array -- FIXING THIS
							newIdAndIndex = { id: id_tb, index_num: index_num_db };
							indexNumFromRowId_global.push(newIdAndIndex);

					// Project title
						title_tb = tableData[i].projectNameHash;

						// Compare i & index_num_db to see if they match
							// Revised version...
							if (title_tb !== title_hash_db) {
								title_tb = "[Invalid]";
							} else {
								if (title_db == "forbidden") {
									let projRefNum = makeProjectRefNumber(bchain_projectKey);
									title_tb = "[ TRN: " + projRefNum + " ]";

									if (showExamples_state == true) {
										if (i === EXAMPLE_INDEX_1) {
											title_tb = "Example Project #2";
										}
										if (i === EXAMPLE_INDEX_2) {
											title_tb = "Example Project #1";
										}
									}
								} else {
									title_tb = title_db;
								}
							}

					// Date/time
						// Open time - conversion
						opentime_tb = convertUnixTime(tableData[i].openTime);
						// Close time - conversion
						closetime_tb = convertUnixTime(tableData[i].closeTime);
					// Restriction
						if (restriction_db == "solo" || restriction_db == "open") {
							restriction_db_hash = hashStringSolidityStyle(restriction_db);
						} else { // i.e. team hash
							restriction_db_hash = restriction_db;
						}

						if (restriction_db_hash !== tableData[i].restriction) {
							restriction_tb = "[Invalid]";
						} else {
							if (restriction_db == "solo" || restriction_db == "open") {
								restriction_tb = restriction_db;
							} else { // i.e. team hash
								restriction_tb = teamName_db;
							}
						}

					rows.push({ id: id_tb, title: title_tb, open: opentime_tb, close: closetime_tb, restriction: restriction_tb });

				} // end of makeRowsWithData function
			}

			console.log("indexNumFromRowId_global: ", indexNumFromRowId_global);

        } else if (emptyTable == true) {

            console.log("emptyTable -b: " + emptyTable);
            console.log('Check ifEmptyShowEmpty: ' + ifEmptyShowEmpty);
			console.log("Check showExamples_state: " + showExamples_state);
			console.log("Check alreadyShowingExamples_state: " + alreadyShowingExamples_state);

            if (ifEmptyShowEmpty == true) {
                console.log('ifEmptyShowEmpty = true');
                rows.push({ id: 1, title: '-----', open: '----', close: '----', restriction: '----' });

            } else { // Probably not needed, but just in case
				// // alert("Testing");
                // console.log('ifEmptyShowEmpty = false');
				// console.log("showExamples_state: " + showExamples_state);
                // getProjectInfoArray(EXAMPLES_ADDRESS); // show project examples
				// // setAreadyShowingExamples(true); 
            }
        }


        function handleRowClick(row) { // row info automatically passed
            console.log("row info: ", row);
            console.log("row id: " + row.id);
			console.log("indexNumFromRowId_global", indexNumFromRowId_global);
			// Get index_num from state array using row.id
				let rowId = row.id;
				let index_num_;
				for (let i=0; i < indexNumFromRowId_global.length; i++) {
					if (indexNumFromRowId_global[i].id == rowId) {
						index_num_ = indexNumFromRowId_global[i].index_num;
						break;
					}
				}
            const address = tableData[index_num_].managerAddress;
			const projectKey = makeProjectKey(index_num_, address);

            navigate('/project?key=' + projectKey);
        }

    // Jump to example pages
      function projectExample(_index) {
		const projectKey = makeProjectKey(_index, EXAMPLES_ADDRESS);
        navigate('/project?key=' + projectKey);
      }


    // Set dark theme
        const darkTheme = createTheme({
            palette: {
                mode: 'dark',
            },
        });
    // Set dim theme
        const dimtheme = createTheme({
          palette: {
            neutral: {
              main: 'rgb(159, 159, 159)',
              contrastText: '#fff',
            },
          },
        });


	// - - - - - - - - - - - - 

    return (

        <div className="App-container">

        {/* Mobile Nav Buttons*/}

			<div className="mobile-nav-buttons" style={{border:"0px solid red", margin:"auto", marginTop:"-15px", display:"none"}}>

				<Button size="small" sx={{ my: 2 }} style={{ marginLeft:"5px", marginTop:'17px'}} onClick={ setupBlockchain }>
					<Link className="nav-menu-mobile" to="/create" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>Create</Link>
				</Button>

				<div style={{ color:'gray', display:'inline-block' }}>|</div> 

				<Button size="small" sx={{ my: 2 }} style={{ marginLeft:"3px", marginTop:'17px'}}>
					<Link className="nav-menu-mobile" to="/browse" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>Browse</Link>
				</Button>

				<div style={{ color:'gray', display:'inline-block' }}>|</div> 

				<Button size="small" sx={{ my: 2 }} style={{ marginLeft:"-5px", marginTop:'17px'}}>
					<Link className="nav-menu-mobile" to="/faq" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>FAQ</Link>
				</Button>
			</div>

        <div className="app-title" style={{ margin:"13px 0px 0px" }}>
			PROJECT TYPE-1
        </div>

		{/* GRAY BOX*/}

			<div style={{ margin:"auto", marginTop: '30px', marginBottom:"-20px", maxWidth:'700px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025)', padding:'15px', paddingTop:'35px', paddingBottom:'50px' }}>

		<ThemeProvider theme={darkTheme}>
		<div className="container">

		<div className="subheading" id="browse-title" style={{ marginTop: "5px", marginBottom: "-22px" }}>B R O W S E</div>

        {/* Virtualized search box */}

          {/* <br/><br/><br/>
          <FormHelperText style={{marginBottom:'8px', textAlign:'center', fontSize:'13px'}}><span style={{color:'rgb(156, 156, 156)'}}>Search with address, username or title</span></FormHelperText>

          <Autocomplete
            id="virtualize-demo"
            sx={{ maxWidth: 300, margin: 'auto', marginBottom: '-55px' }}
            disableListWrap
            PopperComponent={StyledPopper}
            ListboxComponent={ListboxComponent}
            options={OPTIONS}
            groupBy={(option) => option[0].toUpperCase()}
            renderInput={(params) => <TextField {...params} label="Search" />}
            renderOption={(props, option) => [props, option]}
            renderGroup={(params) => params}

            onChange={(event, newValue) => {
                setSelectedValue(newValue); // value selected
                {(() => {
                  if (newValue.split(" ").pop() == "[title]") {
                      let titleSubstr = newValue.split(" [title]").shift();
                      console.log("SPLIT: " + titleSubstr);
                      getProjectWithTitleFromDB(titleSubstr);
                  } else {
                      findAddressFromDB(newValue);
                  }
                })()}
            }}

            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue); // value displayed in textbox
            }}
          /> */}

        {/* End virtualized search box */}


        {/* Wallet / "See Your Projects" button */}

          <div style={{marginTop:'65px', marginBottom:'-80px'}}>
            <div style={{border:'0px solid green', maxWidth:'600px', margin:'auto'}}>

				{ publicMode == false ? (

					web3Node == "wallet" ? (

							<div style={{ margin:'-35px 0px 0px' }} >
								<div style={{ fontSize:'27px', color:'rgb(157, 227, 197)'}} >
									{ username_state }
								</div>

								<div style={{ marginTop:'10px', color:'rgb(169, 169, 169)', fontSize:'15px', fontWeight:'normal', fontFamily:'Arial Narrow', overflowWrap: 'break-word' }}>
									{account_global}
								</div><br/>
							</div>

						) : (

							<Stack direction="row" spacing={1} justifyContent="center">
								{/* <Button size="small">Account Num</Button> */}
								<Button size="small" style={{ minHeight:'25px', fontSize:'11px', fontWeight:'bold', color:'rgb(189, 189, 189)', border:'0px solid gray'}}>
									{/* Showing Examples */}
									See Your Projects
								</Button>

								<Button variant="outlined" size="small" style={{ minHeight:'25px', paddingTop:'4px', fontSize:'11px', fontWeight:'bold', color:'rgb(189, 189, 189)', border:'1px solid rgb(102, 102, 102)'}} onClick={() => { handleMainBlockchainButton() }} >
									Connect
								</Button>
							</Stack>
						)

				) : ( 

					<div style={{ margin:'-35px 0px 0px' }} >
						<div style={{ fontSize:'27px', color:'rgb(157, 227, 197)'}} >
							{ usernamePublic }
						</div>

						<div style={{ marginTop:'10px', color:'rgb(169, 169, 169)', fontSize:'15px', fontWeight:'normal', fontFamily:'Arial Narrow', overflowWrap: 'break-word' }}>
							{userAddrPublic}
						</div><br/>
					</div>
				)
			}

            </div>
          </div>


        {/* Table */}
        
            <div className="table">

				<div style={{ margin:'0px 0px 5px', padding:'5px 6px', maxWidth:'670px', border:'0px solid red', textAlign:'left', fontSize:'15px', color:'rgb(186, 224, 195)'}}>(Click on row to see detail)</div>

                <div style={{ height: 500, width: '100%' }}>
                    <DataGrid
					sx={{
						'& .MuiDataGrid-row:hover': {
							backgroundColor: 'rgb(65, 65, 65, 0.8)', // Light gray on hover
						},
						backgroundColor: '#282c34', // light gray
						color: 'rgb(240, 240, 240)' // optional, for good contrast
					}}
                    rows={rows}
                    columns={columns}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    // checkboxSelection
                    // disableSelectionOnClick
                    onRowClick={handleRowClick}
                    />
                </div>

            </div>
        </div>

        </ThemeProvider>

        <ThemeProvider theme={dimtheme}>
          <Box
            sx={{
              marginTop: '-30px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              '& > *': {
                m: 1,
              },
            }}
          >
            <ButtonGroup variant="text" aria-label="text button group" color="neutral">
              <Button onClick={() => projectExample(EXAMPLE_INDEX_2)}>Example 1</Button>
              <Button onClick={() => projectExample(EXAMPLE_INDEX_1)}>Example 2</Button>
              {/* <Button onClick={() => projectExample(2)}>Example 3</Button> */}
            </ButtonGroup>
          </Box>

        </ThemeProvider>

		{ publicMode === false ? (

			<ThemeProvider theme={dimtheme}>
				<Box sx={{ '& button': { m: 1 } }}>
					<div style={{ marginTop:'18px', marginBottom:'-33px'}}>
						<Button variant="outlined" size="small" color="neutral" onClick={makePublicURL}>
							{copyText}
						</Button>
					</div>
				</Box>
			</ThemeProvider>

			) : ( "" )
		}

		</div> {/* end of gray box */}

        <br/><br/><br/><br/>

      </div>
    );

  }

  export default Browse
